export default {
  colors: {
    black: '#100B08',
    white: '#FEFEFE',
    text: '#292929',
    greenDark: '#4B5F52',
    greenLight: '#5B7C6B',
    orange: '#DB9813',
  },

  fontFamily: {
    caveat: 'Caveat Brush',
    lato: 'Lato',
  },

  fontSize: {
    title1: '5rem', // +- 72px
    title2: '3rem', // 48px
    title3: '2.25rem', // 36px
    text: '1.3125rem', // 21px
    link: '2.125rem', // 34px
    buttonText: '2rem', // 32px
  },
}
